if (!customElements.get('blog-product-block')) {
  class BlogProductBlock extends HTMLElement {
    constructor() {
      super();
      this.sliderInstance = false;
      this.gap = 16;
    }

    connectedCallback() {
      this.wrapper = this.querySelector('.blog-product-block__items');
      this.sliderEl = this.querySelector('.blog-product-block__slider');
      this.prevEl = this.querySelector('.blog-product-block__prev');
      this.nextEl = this.querySelector('.blog-product-block__next');
      this.productCount = parseInt(this.dataset.productCount, 10) || 0;
      this.style.setProperty('--blog-block-gap-px', `${this.gap}px`);

      if (!this.wrapper || this.productCount <= 3) return;

      this.classList.add('blog-product-block--slider');
      this.init();

      this.onResize = FoxTheme.utils.debounce(() => {
        if (this.sliderInstance?.slider) {
          this.sliderInstance.slider.update();
        }
      }, 150);

      window.addEventListener('resize', this.onResize);
      document.addEventListener('matchMobile', () => this.handleBreakpoint());
      document.addEventListener('unmatchMobile', () => this.handleBreakpoint());
    }

    handleBreakpoint() {
      this.destroySlider();
      if (this.productCount > 3) this.init();
    }

    init() {
      if (typeof this.sliderInstance === 'object') return;

      const sliderOptions = {
        slidesPerView: 'auto',
        spaceBetween: this.gap,
        navigation: {
          nextEl: this.nextEl,
          prevEl: this.prevEl,
        },
        pagination: false,
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            spaceBetween: this.gap,
          },
          1024: {
            slidesPerView: 'auto',
            spaceBetween: this.gap,
          },
        },
        loop: this.productCount > 4,
        threshold: 2,
        watchOverflow: true,
      };

      this.sliderEl.classList.add('swiper');
      this.wrapper.classList.add('swiper-wrapper');
      this.sliderInstance = new window.FoxTheme.Carousel(this.sliderEl, sliderOptions);
      this.sliderInstance.init();
    }

    destroySlider() {
      this.sliderEl.classList.remove('swiper');
      this.wrapper.classList.remove('swiper-wrapper');
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }

  customElements.define('blog-product-block', BlogProductBlock);
}
